export default {
  state: {
    title: {}
  },
  mutations: {
    setTitle(state, value) {
      state.title = value;
    }
  }
}